import React, { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import axios from 'axios';
import { GraduationCap } from 'lucide-react';
import { useT } from '../../utils/translate';
import { usePermissions } from '../../utils/permissions';
import { EDU } from './shared';
import { StudentModal } from './StudentsTab';

// Блок в шапке сделки: «Записать в группу» (данные клиента подставляются из сделки и контакта) либо, если ученик уже записан, его группа и остаток занятий.
export default function DealEducation({ deal, contact }) {
  const t = useT();
  const navigate = useNavigate();
  const { can } = usePermissions();
  const on = useSelector((s) => !!s.auth.user?.organization?.education?.enabled);
  const [students, setStudents] = useState(null);
  const [groups, setGroups] = useState([]);
  const [open, setOpen] = useState(false);
  const dealId = deal?._id;
  const allowed = on && can('education', 'view');

  const load = useCallback(async () => {
    if (!allowed || !dealId) return;
    try { const r = await axios.get(`${EDU}/students`, { params: { deal: dealId, status: 'all' } }); setStudents(r.data.students || []); }
    catch { setStudents([]); }
  }, [allowed, dealId]);
  useEffect(() => { load(); }, [load]);

  if (!allowed || !dealId || students === null) return null;
  const openModal = async () => {
    try { const r = await axios.get(`${EDU}/groups`); setGroups(r.data.groups || []); } catch { setGroups([]); }
    setOpen(true);
  };
  const live = students.filter((s) => s.status === 'active' || s.status === 'frozen');

  return (
    <>
      {live.map((s) => (
        <button key={s._id} type="button" onClick={() => navigate('/education/students')} title={t('edu.deal.openStudents')}
          className="hidden sm:inline-flex items-center gap-1.5 text-xs font-medium px-2.5 py-1.5 rounded-lg bg-emerald-50 text-emerald-800 border border-emerald-200 hover:bg-emerald-100">
          <GraduationCap className="w-3.5 h-3.5" />
          {t('edu.deal.enrolled', { group: s.groupInfo?.name || '', n: s.balance?.left ?? 0 })}{s.balance?.debt > 0 ? ` · ${t('edu.today.debt')}` : ''}
        </button>
      ))}
      {can('education', 'create') && (
        <button type="button" onClick={openModal} className="btn-secondary btn-md inline-flex items-center gap-1.5">
          <GraduationCap className="w-4 h-4" /> {live.length ? t('edu.deal.enrollAnother') : t('edu.deal.enroll')}
        </button>
      )}
      {open && (
        groups.length === 0
          ? <NoGroups onClose={() => setOpen(false)} />
          : <StudentModal groups={groups.filter((g) => g.status === 'active')} prefill={{ name: contact?.name || deal.title || '', phone: contact?.phone || '', deal: dealId, contact: contact?._id || deal.contact?._id || deal.contact || '' }}
              onClose={() => setOpen(false)} onSaved={() => { setOpen(false); load(); }} />
      )}
    </>
  );
}

function NoGroups({ onClose }) {
  const t = useT();
  const navigate = useNavigate();
  return (
    <div className="fixed inset-0 z-[80] flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-black/40" onClick={onClose} />
      <div className="relative bg-white rounded-2xl shadow-modal w-full max-w-sm p-5 space-y-4">
        <p className="text-sm text-ink">{t('edu.deal.noGroups')}</p>
        <div className="flex justify-end gap-2">
          <button type="button" className="btn-secondary btn-md" onClick={onClose}>{t('edu.cancel')}</button>
          <button type="button" className="btn-primary btn-md" onClick={() => navigate('/education/groups')}>{t('edu.deal.toGroups')}</button>
        </div>
      </div>
    </div>
  );
}
